import type { GraphQLTypes, InputType, OrganizationStatus } from '@zeus/index'
import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

const orgSelector = Selector('OrganizationModel')({
  id: true,
  name: true,
  slug: true,
  status: true,
  userCount: true,
})

export const GQL_ORGANIZATIONS = typedGql('query')({
  organizations: orgSelector,
})

export const GQL_CREATE_ORGANIZATION = typedGql('mutation')({
  createOrganization: [
    { input: $('input', 'CreateOrganizationInput!') },
    orgSelector,
  ],
})

export const GQL_SET_ORGANIZATION_STATUS = typedGql('mutation')({
  setOrganizationStatus: [
    { id: $('id', 'String!'), status: $('status', 'OrganizationStatus!') },
    orgSelector,
  ],
})

export const GQL_UPDATE_ORGANIZATION = typedGql('mutation')({
  updateOrganization: [
    { input: $('input', 'UpdateOrganizationInput!') },
    orgSelector,
  ],
})

export const GQL_DELETE_ORGANIZATION = typedGql('mutation')({
  deleteOrganization: [{ id: $('id', 'ID!') }, true],
})

const memberSelector = Selector('OrgMemberModel')({
  id: true,
  createdAt: true,
  email: true,
  firstName: true,
  lastName: true,
  role: true,
  status: true,
})

export const GQL_ORGANIZATION_MEMBERS = typedGql('query')({
  organizationMembers: [{ orgId: $('orgId', 'ID!') }, memberSelector],
})

export const GQL_INVITE_ORG_MEMBER = typedGql('mutation')({
  inviteOrgMember: [{ input: $('input', 'InviteOrgMemberInput!') }, memberSelector],
})

export const GQL_REMOVE_ORG_MEMBER = typedGql('mutation')({
  removeOrgMember: [
    { orgId: $('orgId', 'ID!'), userId: $('userId', 'ID!') },
    true,
  ],
})

export type StoredOrganization = InputType<
  GraphQLTypes['OrganizationModel'],
  typeof orgSelector
>

export type StoredOrgMember = InputType<
  GraphQLTypes['OrgMemberModel'],
  typeof memberSelector
>

// Types concrets pour le rendu : les `InputType` zeus résolvent leurs champs en
// `unknown` (inexploitables en accès de champ), d'où ces formes explicites.
export type OrgRow = {
  id: string
  name: string
  slug: string
  status: OrganizationStatus
  userCount: number
}

export type OrgMember = {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  status: string
}
